import { render, staticRenderFns } from "./LiveCom.vue?vue&type=template&id=039cd8e2&scoped=true"
import script from "./LiveCom.vue?vue&type=script&lang=js"
export * from "./LiveCom.vue?vue&type=script&lang=js"
import style0 from "./LiveCom.vue?vue&type=style&index=0&id=039cd8e2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039cd8e2",
  null
  
)

export default component.exports